import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography, Avatar, Fade } from '@mui/material';
import { useInView } from 'react-intersection-observer';

const founders = [
    {
        name: 'Björn Wallin',
        title: 'SME-expert',
        description: [
            'SME-expert having +20 years of experience in different roles such as CEO and Chair of SME-markets.',
            'Last 10 years of global research of SMEs.'
        ],
        image: '/images/bjorn.png',
    },
    {
        name: 'Dr Anders Karlsson',
        title: 'Professor/Doctor of mathematics',
        description: [
            'Professor/Doctor of mathematic of University of Geneva after studies at Yale University.',
            'Dr Karlsson is a well-requested lecturer on AI in Europe, Asia and US.'
        ],
        image: '/images/anders.png',
    },
    {
        name: 'Per Hagström',
        title: 'Senior Software Engineer',
        description: [
            'A senior software engineer with +20 years experience of implementing scalable data architectures.',
            'Also experience from real-time processing of “apps”.'
        ],
        image: '/images/pelle.png',
    }
];

const Founders: React.FC = () => {
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });
    const [visibleIndexes, setVisibleIndexes] = useState<number[]>([]);

    useEffect(() => {
        if (inView) {
            founders.forEach((_, index) => {
                setTimeout(() => {
                    setVisibleIndexes(prev => [...prev, index]);
                }, index * 400);
            });
        }
    }, [inView]);

    return (
        <Box sx={{ backgroundColor: '#0e0e0e', py: 6, px: 2 }} ref={ref}>
            <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
                <Typography
                    variant="h3"
                    sx={{ textAlign: 'center', mb: 8, color: '#fff' }}
                >
                    Founders Team
                </Typography>

                <Grid container spacing={4} justifyContent="center">
                    {founders.map((founder, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Fade in={visibleIndexes.includes(index)} timeout={1400}>
                                <Box
                                    sx={{
                                        textAlign: 'left',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 1,
                                        width: 250,
                                        mx: 'auto',
                                    }}
                                >
                                    <Avatar
                                        src={founder.image}
                                        alt={founder.name}
                                        variant="rounded"
                                        sx={{
                                            width: 250,
                                            height: 250,
                                            borderRadius: 2,
                                            mb: 1,
                                        }}
                                    />
                                    <Typography variant="subtitle1" fontWeight="bold" color="white">
                                        {founder.name}
                                    </Typography>
                                    <Typography variant="body2" color="white" fontStyle="italic">
                                        {founder.title}
                                    </Typography>
                                    {founder.description.map((line, i) => (
                                        <Typography key={i} variant="body2" color="#cccccc">
                                            {line}
                                        </Typography>
                                    ))}
                                </Box>
                            </Fade>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
};

export default Founders;
